import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Dropdown extends Component {
	static propTypes = {
		title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
		items: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
		onSelect: PropTypes.func.isRequired,
	};

	state = {
		isOpen: false,
	};

	componentDidMount() {
		document.addEventListener('click', this.handleDocumentClick.bind(this));
	}

	componentWillUnmount() {
		document.removeEventListener('click', this.handleDocumentClick.bind(this));
	}

	mouseWasDown = false;
	mouseWasUp = false;

	handleDocumentClick() {
		if (!this.mouseWasDown && !this.mouseWasUp && this.state.isOpen) {
			this.setState({ isOpen: false });
		}

		this.mouseWasDown = false;
		this.mouseWasUp = false;
	}

	toggle(e) {
		e.preventDefault();
		this.setState({ isOpen: !this.state.isOpen });
	}

	handleMouseDown() {
		this.mouseWasDown = true;
	}

	handleMouseUp() {
		this.mouseWasUp = true;
	}

	handleSelect = e => {
		e.preventDefault();
		this.props.onSelect(e.target.getAttribute('value'));
		this.setState({ isOpen: false });
	};

	render() {
		const classes = `dropdown ${this.state.isOpen ? 'open' : ''}`;

		return (
			<div
				className={classes}
				onMouseDown={this.handleMouseDown.bind(this)}
				onMouseUp={this.handleMouseUp.bind(this)}
			>
				<button
					className="btn btn-default dropdown-toggle"
					onClick={this.toggle.bind(this)}
				>
					{this.props.title}
					<span className="glyphicon glyphicon-triangle-bottom DayPicker-Caret" />
				</button>
				<ul className="dropdown-menu">
					{this.props.items.map(i =>
						<li key={i.value} role="presentation" className="">
							<a href="#" value={i.value} onClick={this.handleSelect}>
								{i.text}
							</a>
						</li>
					)}
				</ul>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/Dropdown/index.js